import {Autocomplete, FormControl, TextField,} from '@mui/material';
import React, {useCallback, useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {DataSource} from '../../models/models';

type Props = {
    dataSources: DataSource[];
    selectedIds: number[];
    onChange: (ids: number[]) => void;
};


const DataSourceMultiSelect: React.FC<Props> = ({
                                                    dataSources,
                                                    selectedIds,
                                                    onChange,
                                                }) => {
    const {t} = useTranslation();

    const handleAutocompleteChange = useCallback(
        (
            _: React.SyntheticEvent,
            value: DataSource[]
        ) => {
            onChange(value.map(v => v.id));
        },
        [onChange]
    );

    const autocompleteValue = useMemo(
        () => dataSources.filter(source => selectedIds.includes(source.id)),
        [dataSources, selectedIds]
    );

    return (
        <FormControl
            sx={{
                m: 1,
                width: '96%',
                margin: '8px 0',
                '&:not(:focus-within) .MuiInputLabel-root': {
                    top: '-3px'
                }
            }}
        >
            <Autocomplete
                multiple
                id="dataSources"
                options={dataSources}
                value={autocompleteValue}
                onChange={handleAutocompleteChange}
                getOptionLabel={(source) => source.name}
                getOptionKey={(source) => source.id}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                limitTags={2}
                renderInput={(dataSources) => (
                    <TextField
                        {...dataSources}
                        variant="standard"
                        label={t('multiSelect.dataSources')}
                    />
                )}
            />
        </FormControl>
    );
};

export default DataSourceMultiSelect;
